<template>
 <div>
   <div class="list">
     <div class="list-item" @click="verifyWithMask">人脸实名验证</div>
   </div>
 </div>
</template>

<script>
export default {
  name: "index",
  methods: {
    verifyWithoutMask() {
      this.$router.push('/singleAction')
    },
    verifyWithMask() {
      this.$router.push('/quiet')
    }
  }
}
</script>

<style scoped lang="less">
.list {
  padding: 50px 30px;
  &-item {
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    background-color: #2b6814;
    color: #fff;
    cursor: pointer;
    & + .list-item {
      margin-top: 30px;
    }
  }
}
</style>
  
